<div [ngClass]="isCollapsed ? 'collapse' : 'expand'" class="menu-container" data-cy="desktop-navbar">
  <div class="top-menu">
    <div (click)="toggleCollapsed()" class="navigation-button-collapse" data-cy="burger-btn">
      @if (!isCollapsed) {
        <div class="row-menu row-menu--expanded">
          <img [alt]="'home.navigation-menu.brand-home' | translate" class="menu-title" src="assets/pictures/qima-one-logo.png" />
        </div>
      } @else {
        @if (isCollapsed) {
          <qp-icon class="navigation-button-collapse__logo" [name]="iconNames.IC_QIMA_Q_LOGO"></qp-icon>
        }
      }
      <div class="navigation-button-collapse__direction">
        <qp-icon [class.navigation-button-collapse__direction-icon]="!isCollapsed" [name]="iconNames.IC_CHEVRON_RIGHT"></qp-icon>
      </div>
    </div>
    <ul [ngClass]="isCollapsed ? 'collapse' : 'expand'" [nzInlineCollapsed]="isCollapsed" class="navigation-menu" nz-menu nzMode="inline">
      @for (menu of menuList; track menu.routerLink) {
        <li class="menu" nz-menu-item>
          <a
            [attr.data-cy]="menu.dataCy"
            qimaTooltip
            qimaTooltipHasArrow="true"
            [qimaTooltipText]="menu.title | translate"
            [qimaTooltipPosition]="qimaPositions.RIGHT"
            [qimaTooltipIsVisible]="isCollapsed"
            [routerLinkActiveOptions]="menu.routerLinkActiveOption"
            [routerLinkActive]="(menu.defaultPageRoute?.routerLink || menu.routerLink) !== commonRoutes.comingSoon() ? 'menu-selected' : ''"
            [routerLink]="menu.defaultPageRoute?.routerLink || menu.routerLink"
            class="menu-item"
          >
            <span class="row-menu" title>
              <em [nzType]="menu.iconName" nz-icon></em>
              <span class="item">{{ menu.title | translate }}</span>
              @if (menu.menuBadgeLabel && !isCollapsed) {
                <qima-badge
                  class="menu-badge"
                  [qimaBadgeLabel]="menu.menuBadgeLabel | translate"
                  [qimaBadgeSize]="qimaBadgeSizes.SMALL"
                ></qima-badge>
              }
            </span>
          </a>
        </li>
      }
      @if (academyUrl) {
        <li class="menu" nz-menu-item>
          <a
            [href]="academyUrl"
            qimaTooltip
            qimaTooltipHasArrow="true"
            [qimaTooltipText]="'home.navigation-menu.academy-menu' | translate"
            [qimaTooltipPosition]="qimaPositions.RIGHT"
            [qimaTooltipIsVisible]="isCollapsed"
            class="menu-item"
            target="_blank"
          >
            <span class="row-menu" title>
              <em nz-icon nzType="ic-academy"></em>
              <span class="item">{{ 'home.navigation-menu.academy-menu' | translate }}</span>
            </span>
          </a>
        </li>
      }
      @if (middleMenuList.length > 0) {
        <qp-divider class="menu-divider" [color]="dividerColors.PEARL"></qp-divider>
      }
      @for (menu of middleMenuList; track menu.routerLink) {
        <li class="menu" nz-menu-item>
          <a
            [attr.data-cy]="menu.dataCy"
            qimaTooltip
            qimaTooltipHasArrow="true"
            [qimaTooltipText]="menu.title | translate"
            [qimaTooltipPosition]="qimaPositions.RIGHT"
            [qimaTooltipIsVisible]="isCollapsed"
            [routerLinkActiveOptions]="menu.routerLinkActiveOption"
            [routerLinkActive]="(menu.defaultPageRoute?.routerLink || menu.routerLink) !== commonRoutes.comingSoon() ? 'menu-selected' : ''"
            [routerLink]="menu.defaultPageRoute?.routerLink || menu.routerLink"
            class="menu-item"
          >
            <span class="row-menu" title>
              <em [nzType]="menu.iconName" nz-icon></em>
              <span class="item">{{ menu.title | translate }}</span>
              @if (menu.menuBadgeLabel && !isCollapsed) {
                <qima-badge
                  class="menu-badge"
                  [qimaBadgeLabel]="menu.menuBadgeLabel | translate"
                  [qimaBadgeSize]="qimaBadgeSizes.SMALL"
                ></qima-badge>
              }
            </span>
          </a>
        </li>
      }
    </ul>
  </div>

  <div class="bottom-menu">
    <qp-divider [color]="dividerColors.PEARL"></qp-divider>
    @if (!isCollapsed) {
      <div class="bottom-grid">
        <div class="brand-name" data-cy="brand-name">{{ account?.companyName }}</div>
        <div class="action-col">
          @if (isSupervisor) {
            <div class="separate"></div>
            <button (click)="switchBrand()" [disabled]="isSwitchingBrand" data-cy="switch-user-btn" type="button">
              <em [nzType]="'ic-repeat'" nz-icon></em>
            </button>
          }
        </div>
        <a
          [attr.data-cy]="accountRoute?.dataCy"
          [routerLinkActiveOptions]="accountRoute?.routerLinkActiveOption"
          [routerLinkActive]="
            (accountRoute?.defaultPageRoute?.routerLink || accountRoute?.routerLink) !== commonRoutes.comingSoon() ? 'menu-selected' : ''
          "
          [routerLink]="accountRoute?.defaultPageRoute?.routerLink || accountRoute?.routerLink"
          class="profile menu-item"
        >
          <div class="picture">
            <img
              [src]="'/api/users/' + account?.id + '/profile-picture'"
              qpFallbackImage
              [qpFallbackImageUrl]="defaultPictureUrl"
              alt="profile picture"
            />
          </div>
          <div class="information expand">
            <div class="name">{{ account?.firstName }}</div>
            <div class="role">{{ account?.profiles?.[0] | oneAuthorityLabel | translate }}</div>
          </div>
          @for (subEntity of accountRoute?.children; track subEntity.routerLink) {
            <a [routerLink]="subEntity?.routerLink"></a>
          }
        </a>
        <div class="action-col">
          <div class="separate"></div>
          <a (click)="tryLoggingOut()" data-cy="logout-btn">
            <em [nzType]="'ic-logout'" nz-icon></em>
          </a>
        </div>
      </div>
    } @else {
      <div class="logout-container">
        <a
          [attr.data-cy]="accountRoute?.dataCy"
          [routerLinkActiveOptions]="accountRoute?.routerLinkActiveOption"
          [routerLinkActive]="
            (accountRoute?.defaultPageRoute?.routerLink || accountRoute?.routerLink) !== commonRoutes.comingSoon() ? 'menu-selected' : ''
          "
          [routerLink]="accountRoute?.defaultPageRoute?.routerLink || accountRoute?.routerLink"
          class="profile menu-item"
        >
          <div class="picture">
            <img
              [src]="'/api/users/' + account?.id + '/profile-picture'"
              qpFallbackImage
              [qpFallbackImageUrl]="defaultPictureUrl"
              alt="profile picture"
            />
          </div>
          <div class="information collapse">
            <div class="name">{{ account?.firstName }}</div>
            <div class="role">{{ account?.profiles?.[0] | oneAuthorityLabel | translate }}</div>
          </div>
          @for (subEntity of accountRoute?.children; track subEntity.routerLink) {
            <a [routerLink]="subEntity?.routerLink"></a>
          }
        </a>
        <div class="logout-btn collapse">
          <div class="separate"></div>
          <a (click)="tryLoggingOut()" data-cy="logout-btn">
            <em [nzType]="'ic-logout'" nz-icon></em>
          </a>
        </div>
      </div>
    }
  </div>
</div>
